import React from "react";
import LayoutBasic from "../../layouts/LayoutBasic";
import AccountSubpage from "../../modules/AccountSubpage";

const AccountPage = () => {
  return (
    <div >
    <LayoutBasic>
      <AccountSubpage ></AccountSubpage>
    </LayoutBasic>
    </div>
  );
};

export default AccountPage;
